import React, { useEffect, useState } from 'react';
import { CircleButton, LinkText, NavigationItemLink, Typography } from '../../index';

export const NavigationSubItem = ({
    label,
    subNavItems,
    isSelectedLink = () => { },
    onDismiss = () => { },
    onSubItemClick = () => { },
    toggleMainMenu = () => { }
}) => {

    return <div className={`bsw-navigation__sliding-menu`}>
        <LinkText
            as="button"
            type="button"
            className="bsw-navigation__sliding-menu-header"
            onClick={(e) => { onDismiss(e, '', ''); }}
            typographyProps={{
                type: "body-02",
                color: "$color-primary-a2",
                bold: true,
                underline: false
            }}
        >
            <CircleButton
                as={'div'}
                colorStyle='float'
                icon="chevron-left"
                size="small"
            />
            {label}
        </LinkText>
        <ul>
            {(subNavItems && subNavItems.length > 0) && subNavItems.map((navItem, index) => {

                return <li
                    className={`bsw-navigation__sub-item`}
                    data-key={index}
                    key={index}
                >
                    <NavigationItemLink
                        index={index}
                        key={index}
                        navItem={navItem}
                        onItemClick={(e, itemIndex, itemLabel) => { onSubItemClick(e, itemIndex, itemLabel); }}
                        isSelectedLink={(navLink, altUrls) => isSelectedLink(navLink, altUrls)}
                        toggleMainMenu={toggleMainMenu}
                    />
                </li>
            })}
        </ul>
    </div>
}
